require('./bootstrap');

import '@fortawesome/fontawesome-pro/css/all.css';
import '@fortawesome/fontawesome-pro/js/all.js';

//var mainNavFixed = false;
var fullScreenPanel = false;
var prevPageScrollTop = 0;
var prevHref = null;

$(window).on('scroll', function () {
    setMainNav();
});
$(window).on('resize', function () {
    setMainNav();
});

function setMainNav() {
    //console.log('set main nav', mainNavFixed ? 'true' : 'false', fullScreenPanel ? 'true' : 'false');
    const href = document.location.href;
    if (href != prevHref) {
        prevPageScrollTop = 0;
        prevHref = href;
    }
    let pageScrollTop = parseInt($('html, body').scrollTop());
    if (pageScrollTop == 0) {
        if ($('html, body').outerHeight() > $(window).height()) {
            pageScrollTop = prevPageScrollTop;
            $('html, body').scrollTop(pageScrollTop);
        }
    } else {
        prevPageScrollTop = pageScrollTop;
    }

    let headerBarHeight = $('.header-bar').outerHeight() || 0;
    if ($('.maintenance-notice').is(":visible")) {
        headerBarHeight += $('.maintenance-notice').outerHeight() || 0;
    }
    const mainNavHeight = $('.main-nav-container').outerHeight();
    const windowWidth = $(window).width();
    const mainNavFixed = $('.main-nav-container').hasClass('fixed');
    //console.log('pageScrollTop:', pageScrollTop, 'headerBarHeight:', headerBarHeight, 'mainNavFixed: ', mainNavFixed ? 'true' : 'false');
    if (fullScreenPanel || (pageScrollTop > headerBarHeight)) {
        if (!mainNavFixed) {
            //mainNavFixed = true;
            $('.main-nav-container').addClass('fixed');
            $('.navbar-brand-box').css({'padding-left': '1.7rem', 'padding-right': '0.75rem'});
            $('.page-content').css('margin-top', mainNavHeight);
            $('.logo-lg > img').css({
                'display': 'inline',
                'height': '0px'
            });
            $('.logo-lg > img').animate({height: '30px'});
            $('.logo-sm > img').css({
                'display': 'inline',
                'height': '0px'
            });
            $('.logo-sm > img').animate({height: '22px'});
        }
        if (windowWidth >= 768) {
            const statusBarHeight = $('.status-bar').outerHeight() || 0;
            $('.collaborate-bar').css('top', pageScrollTop - mainNavHeight + 47 + statusBarHeight);
        } else {
            $('.collaborate-bar').css('top', 'unset');
        }
    } else {
        if (mainNavFixed) {
            //mainNavFixed = false;
            $('.main-nav-container').removeClass('fixed');
            $('.navbar-brand-box').css({'padding-left': '0.75rem', 'padding-right': 0});
            $('.page-content').css('margin-top', 0);
            $('.logo-lg > img').animate({height: '0px'}, function () {
                $('.logo-lg > img').css({
                    'display': 'none',
                    'height': '0px'
                });
            });
            $('.logo-sm > img').animate({height: '0px'}, function () {
                $('.logo-sm > img').css({
                    'display': 'none',
                    'height': '0px'
                });
            });
            if (windowWidth >= 768) {
                $('.collaborate-bar').css('top', 0);
            } else {
                $('.collaborate-bar').css('top', 'unset');
            }
        }
    }

    if (fullScreenPanel && (pageScrollTop > 30)) {
        let width = 0;
        let height = 0;
        width = Math.ceil($('.artwork-editor-header').outerWidth());
        let bodyWidth = Math.ceil($('.artwork-editor-body').outerWidth());
        let editorSizeChanged = false;
        if (!$('.artwork-editor-header').hasClass('fixed') || (width != bodyWidth)) {
            editorSizeChanged = true;
            //console.log('change editor size');
            //width = Math.ceil($('.artwork-editor-header').outerWidth());
            width = bodyWidth;
            height = Math.ceil($('.artwork-editor-header').outerHeight());
            $('.artwork-editor-body').css('padding-top', height);
            $('.artwork-editor-header').css('width', width);
            $('.artwork-editor-header').addClass('shadow-sm');
            $('.artwork-editor-header').addClass('fixed');
            
            $('.content-suggestion-button-div').addClass('fixed');
            $('.content-suggestion-button-div').css('width', $('.template-fields').width());
            $('.content-suggestion-button-div').css(
                'top',
                $('.main-nav-container').outerHeight() + $('.artwork-editor-header').outerHeight()
            );
        }
        height = Math.ceil($('#artwork-editor .asset-preview.page .thumbnail').height());
        if (
            (editorSizeChanged || ($('.template-fields').outerHeight() > height))
            && $('#artwork-editor .asset-preview.page').hasClass('template-preview-sm')
        ) {
            //console.log('change editor size 2');
            const editorHeaderHeight = $('.artwork-editor-header').outerHeight();
            const fitScreenHeight = $(window).height() - editorHeaderHeight - $('.asset-selection').height() - 110;
            let outOfRangeHeight = $('.template-preview-sm').outerHeight() - fitScreenHeight;
            if (outOfRangeHeight < 0) {
                outOfRangeHeight = 0;
            }
            if (pageScrollTop > (30 + outOfRangeHeight)) {
                //console.log('change editor size 3');
                if (!$('.template-preview-sm').hasClass('fixed') || editorSizeChanged) {
                    //width = Math.ceil($('.template-preview-sm').width());
                    width = Math.ceil($('.artwork-editor-preview-col').width());
                    $('.template-preview-sm').css({
                        'width': width,
                        'top': (70 + editorHeaderHeight - outOfRangeHeight)
                    });
                    if (!$('.template-preview-sm').hasClass('fixed')) {
                        $('.template-preview-sm').addClass('fixed');
                    }
                }
            } else {
                $('#artwork-editor .asset-preview.page').removeClass('fixed');
                $('#artwork-editor .asset-preview.page').css({
                    'top': 0,
                    'width': 'auto'
                });
            }
        } else {
            $('#artwork-editor .asset-preview.page').removeClass('fixed');
            $('#artwork-editor .asset-preview.page').css({
                'top': 0,
                'width': 'auto'
            });
        }
    } else {
        $('.artwork-editor-body').css('padding-top', 0);
        $('.artwork-editor-header').css('width', 'auto');
        $('.artwork-editor-header').removeClass('shadow-sm');
        $('.artwork-editor-header').removeClass('fixed');
        $('.template-preview-xs').css('top', 0);
        $('.template-preview-sm').css('top', 0);
        $('#artwork-editor .asset-preview.page').removeClass('fixed');
        $('#artwork-editor .asset-preview.page').css({
            'top': 0,
            'width': 'auto'
        });

        $('.content-suggestion-button-div').removeClass('fixed');
        $('.content-suggestion-button-div').css('width', 'auto');
        $('.content-suggestion-button-div').css('top', 0);
    }
}

setInterval(function () {
    const addingAsset = $('body').hasClass('asset-add');
    const addingTemplate = $('body').hasClass('template-add');
    const editingArtwork = ($('body').hasClass('artwork-edit') || $('body').hasClass('img-ly-demo'));
    const editingImgLyScene = ($('body').hasClass('img-ly-scene-edit'));

    if (fullScreenPanel != (addingAsset || addingTemplate || editingArtwork || editingImgLyScene)) {
        fullScreenPanel = (addingAsset || addingTemplate || editingArtwork || editingImgLyScene);
        const mainNavFixed = $('.main-nav-container').hasClass('fixed');
        if (fullScreenPanel && mainNavFixed) {
            $('.page-content').css('margin-top', $('.main-nav-container').outerHeight());
        }
        /*setTimeout(function () {
            setMainNav();
        }, 100);*/
    }
    setMainNav();
}, 200);
